import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import icPhone from "@iconify/icons-ic/twotone-phone";
import icClose from "@iconify/icons-ic/twotone-close";

@Component({
    selector: "vex-profile-dialog",
    templateUrl: "./profile-dialog.component.html",
    styleUrls: ["./profile-dialog.component.scss"],
})
export class ProfileDialogComponent implements OnInit {
    form: FormGroup;

    icClose = icClose;
    icPhone = icPhone;

    constructor(
        @Inject(MAT_DIALOG_DATA) public defaults: any,
        private dialogRef: MatDialogRef<ProfileDialogComponent>,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            email: "user@gmail.com",
            phoneNumber: "1234567890",
            password: "",
            cpassword: "",
        });
    }

    save() {
        this.dialogRef.close();
    }
}
